import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Layout,
  LayoutItem,
  Well,
  useApi,
  CondensedHeader,
} from '@axiom/ui';
import type { Candidate, CandidateRedux } from '@axiom/validation';

import { TalentWhiteboardApi } from '../../api/talent-whiteboard-api';

import { TalentAvailabilityNotesEdit } from './TalentAvailabilityNotesEdit';
import { TalentAvailabilityNotesDisplay } from './TalentAvailabilityNotesDisplay';

export type TalentAvailabilityNotesProps = {
  candidate: CandidateRedux | Candidate;
  name: string;
};

export const TalentAvailabilityNotes = ({
  candidate,
  name,
}: TalentAvailabilityNotesProps) => {
  const { id } = candidate;
  const [editingNotes, setEditingNotes] = useState(false);
  const [{ data: note }] = useApi(TalentWhiteboardApi.readCandidateNotes(id));

  useEffect(() => {
    setEditingNotes(false);
  }, [candidate]);

  return (
    <Well name={name}>
      <Layout>
        <LayoutItem position="left">
          <CondensedHeader>Internal Note</CondensedHeader>
        </LayoutItem>
        {!editingNotes && (
          <LayoutItem position="right" fluid>
            <IconButton
              pattern="secondary"
              variation="minimal"
              icon="pencil"
              onClick={() => {
                setEditingNotes(true);
              }}
              name="EDIT_NOTES"
            />
          </LayoutItem>
        )}
      </Layout>

      {editingNotes ? (
        <TalentAvailabilityNotesEdit
          candidate={candidate}
          note={note}
          setEditingNotes={setEditingNotes}
        />
      ) : (
        <TalentAvailabilityNotesDisplay note={note} />
      )}
    </Well>
  );
};
